import request from "@/request";

/**
 * 获取菜单
 * @returns {AxiosPromise}
 */
export function menu_list() {
  return request({ url: "/api/v1/menu/list", method: "GET" });
}
/**
 * 添加/修改菜单
 * @param data
 * @returns {AxiosPromise}
 */
export function menu_modify(data) {
  return request({ url: "/api/v1/menu/modify", method: "POST", data: data });
}

/**
 * 删除菜单
 * @param data
 * @returns {AxiosPromise}
 */
export function menu_delete(data) {
  return request({ url: "/api/v1/menu/delete", method: "POST", data: data });
}

/**
 * 修改菜单状态
 * @param data
 * @returns {AxiosPromise}
 */
export function menu_modify_status(data) {
  return request({
    url: "/api/v1/menu/modify_status",
    method: "POST",
    data: data,
  });
}
